import styles from './styles.module.css'
import { COUNTRY_INFO } from '../../constans/countries/countries'
import { useDataLoader } from '../../components/hooks/useDataLoader'
import { useSelector } from 'react-redux'
import { CountryNamesMobileContainer } from '../../components/CountryNamesContainer/CountryNamesMobileContainer'
import { NavLink } from 'react-router-dom'

export const AllCountriesNamesPageMobile = () => {

  useSelector((state) => state.visitedList);
  useSelector((state) => state.wishList);
    
  useDataLoader();
  
  const mainSlice = COUNTRY_INFO.map(e =>
    <div className={styles.all_names_mobile}>
      <CountryNamesMobileContainer children={e} />
    </div>
    
  )
 
  return (
   <div className={styles.root_mobile}>
    {mainSlice}
    <h1 className={styles.seo_text_h1}>Here is a collection of 250 world countries by name</h1>
    <h2 className={styles.seo_text}>
      This is probably all the existing countries in the world. Why "probably"? Because there are a lot of unrecognized or partially recognized countries that we didn't display here. Also, there are countries that have changed their name or flag and we haven't noticed yet — but we will.
      <br />The countries here are sorted alphabetically by their name, and you can see their flag by tapping on the name.
      You can also add a country to a wishlist or to a list of countries you have already visited — just tap the "like" button or the "add" button. Then you can send a link to this list to your friends via messengers, or post it on X (formerly Twitter) or other social networks. 
      <br />There is also a page with the <NavLink className={styles.names_link} to={'/allflags'}>flags</NavLink> of the same countries, featuring the same buttons.
    </h2>
   </div>
  )
}